module.exports = __webpack_public_path__ + "img/logo.f640c887.svg";